module.exports = __webpack_public_path__ + "static/media/play-button-image.3be83d5f.svg";